export default "__VITE_ASSET__28Xc2g2S__"